import { Flag, useFlag, v2_useCmsBlock } from '@crocodille/common';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './shipping-page-layout-2.module.scss';
import Button from '@components/elements/button/button';
import Image from 'next/image';
import appImage from '../../../../public/bb_app.png';
import LoyaltyStatus from '@components/loyalty/loyalty-status/loyalty-status';
import AppApprovedIcon from '@components/icons/app-approved-icon';

const Splash: React.FC = () => {
  const { t } = useTranslation();

  const isInWebView = useFlag(Flag.IS_IN_WEBVIEW);

  return (
    <div className={styles.splash}>
      {!isInWebView ? (
        <>
          <h1 className={styles.splashText}>{t('shipping.page_heading')}</h1>
        </>
      ) : null}
    </div>
  );
};

const AppCard: React.FC = () => {
  const { t } = useTranslation();

  const { data: appPromoBlock } = v2_useCmsBlock('app_promo_banner');

  const handleAppCardClick = useCallback(() => {
    if (!appPromoBlock?.link) {
      return;
    }

    window.location.href = appPromoBlock.link;
  }, [appPromoBlock]);

  return (
    <>
      <div className={styles.appCardContainer} onClick={handleAppCardClick}>
        <div className={styles.imageContainer}>
          <Image
            src={appImage}
            alt="BB app image"
            role="presentation"
            className={styles.appImage}
          />
        </div>
        <div className={styles.infoContainer}>
          <AppApprovedIcon className={styles.icon} />
          <div className={styles.text}>{t('download_app_with_coupon')}</div>
          <Button round variant="secondary" className={styles.appBtn}>
            {t('download_app')}
          </Button>
        </div>
      </div>
    </>
  );
};

const Intro: React.FC<React.PropsWithChildren<Record<string, unknown>>> = ({
  children,
}) => {
  return (
    <>
      <div className={styles.loyaltyContainer}>
        <LoyaltyStatus isMobileVisible />
      </div>
      <div className={styles.intro}>
        <div className={styles.shippingContainer}>
          <Splash />
          <div className={styles.card}>{children}</div>
        </div>
        <div className={styles.appContainer}>
          <AppCard />
        </div>
      </div>
    </>
  );
};

const Products: React.FC<React.PropsWithChildren<Record<string, unknown>>> = ({
  children,
}) => {
  return (
    <div className={styles.products}>
      {children}
      <div className={styles.appContainer}>
        <AppCard />
      </div>
    </div>
  );
};

const Restaurants: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  return <div className={styles.restaurants}>{children}</div>;
};

const Promotions: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  return <div className={styles.promotions}>{children}</div>;
};

const OrderRepeat: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  return <div className={styles.orderRepeat}>{children}</div>;
};

export const ShippingPageLayoutElement: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

const ShippingPageLayout = Object.assign(ShippingPageLayoutElement, {
  Intro,
  Promotions,
  OrderRepeat,
  Products,
  Restaurants,
});

export default ShippingPageLayout;
